<template>
  <div>
    <v-app-bar app flat dark color="primary">
      <v-app-bar-nav-icon
        @click.native.stop="updateUILeftDrawerState(!UILeftDrawer)"
        v-if="!screenIsWideEnough"
      ></v-app-bar-nav-icon>
      <v-icon v-else>fad fa-ad</v-icon>
      <v-toolbar-title class="ml-0 pl-3">Adverts</v-toolbar-title>
    </v-app-bar>
    <v-content>
      <v-container fill-height fluid class="pa-0 calc-height grey lighten-2">
        <v-layout :class="{ 'ml-0': $vuetify.breakpoint.width <= 1600, 'ml-4': $vuetify.breakpoint.width > 1600 }">
          <v-flex
            style="overflow-y: auto;border-right: 1px solid #ddd;min-width:280px;max-width:280px;width:280px"
            :class="{ hidden: !screenIsWideEnough }"
          >
            <AdvertList></AdvertList>
          </v-flex>
          <v-flex :class="{ 'ml-0': $vuetify.breakpoint.width <= 1600, 'ml-4': $vuetify.breakpoint.width > 1600 }">
            <v-card flat>
              <v-tabs background-color="grey lighten-3" v-model="tabs">
                <v-tabs-slider color="accent"></v-tabs-slider>
                <v-tab key="details">Details</v-tab>
                <v-tab key="exclusions">Exclusions</v-tab>
              </v-tabs>
            </v-card>
            <v-tabs-items v-model="tabs">
              <v-tab-item key="details">
                <Advert :advert="SelectedAdvert" v-if="SelectedAdvert"></Advert>
              </v-tab-item>
              <v-tab-item key="exclusions">
                <AdvertExclusions :advert="SelectedAdvert"></AdvertExclusions>
              </v-tab-item>
            </v-tabs-items>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-fab-transition>
      <v-btn
        color="accent darken-1"
        dark
        fab
        fixed
        bottom
        right
        @click.stop="showDialog = true"
        v-if="UserHasRole('Platform')"
      >
        <v-icon>fas fa-layer-plus</v-icon>
      </v-btn>
    </v-fab-transition>
    <new-advert-dialog :show.sync="showDialog"></new-advert-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AdvertList from './AdvertList';
import NewAdvertDialog from './NewAdvertDialog';
import Advert from './Advert';
import AdvertExclusions from './AdvertExclusions';

export default {
  name: 'Adverts',
  components: { AdvertExclusions, Advert, NewAdvertDialog, AdvertList },
  data: () => ({
    tabs: null,
    showDialog: false
  }),
  computed: {
    ...mapGetters(['SelectedAdvert', 'UILeftDrawer', 'UserHasRole'])
  },
  methods: {
    ...mapActions(['updateUILeftDrawerState']),
    screenIsWideEnough: function() {
      return this.$vuetify.breakpoint.width > 1600;
    }
  }
};
</script>

<style lang="scss" scoped>
.calc-height {
  height: calc(100vh - 64px);
  max-height: calc(100vh - 64px);
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}

::v-deep {
  .input-group--text-field input,
  .input-group__selections__comma {
    font-size: 13px;
  }
}

::v-deep textarea {
  font-size: 13px;
}

.theme--light {
  .input-group.input-group--solo-inverted.input-group--focused {
    background-color: #fff;
    ::v-deep input,
    ::v-deep .input-group__prepend-icon {
      color: rgba(0, 0, 0, 0.78);
    }
  }
  .subheader.text--accent-1 {
    color: #e91e63;
  }
  &.v-list {
    background: inherit;
  }
}

.btn-toggle--selected {
  box-shadow: none;

  .btn--active {
    color: #e91e63;

    > .btn__content:before {
      opacity: 0;
    }
  }
}

.theme--light .subheader.text--accent-1 {
  color: #e91e63;
}

::v-deep .tabs__item--active {
  color: #2196f3;
}

.hidden {
  display: none;
}

.selected {
  background: #b08faf;
  color: white;

  .list__tile__title {
    font-weight: 600;
  }

  .list__tile__sub-title {
    color: rgba(255, 255, 255, 0.87);
  }
}
</style>
